import { t } from 'i18next'

import { ListaProcuradores, ListaVinculosComprador } from '@/features/proposta/brasil/components'
import type { TProcurador } from '@/features/proposta/brasil/types/compradores.types'
import type { TCompradoresCadastrados } from '@/features/proposta/brasil/types/proposta.type'
import {
  CardComprador,
  CardCompradorContent,
  CardCompradorHeader,
  CardCompradorInfo,
} from '@/features/proposta/shared/components/etapa-comprador/card-comprador'

type TListaCompradoresProps = {
  compradores: TCompradoresCadastrados
  onExcluir: (id: string) => void
  onEdit: (
    cliente: TCompradoresCadastrados[number] | TCompradoresCadastrados[number]['vinculos'][number] | TProcurador,
    comprador: TCompradoresCadastrados[number],
  ) => void
  obterProcuradoresDoComprador: (compradorId: string) => TProcurador[]
}

export const ListaCompradores = ({
  compradores,
  onExcluir,
  onEdit,
  obterProcuradoresDoComprador,
}: TListaCompradoresProps) => {
  return (
    <>
      {compradores.map((comprador, i) => (
        <CardComprador key={comprador.id}>
          <CardCompradorHeader onDelete={() => onExcluir(comprador.id)}>
            {t('proposta:cadastro_compradores.comprador', { numero: i + 1 })}
          </CardCompradorHeader>
          <CardCompradorContent onEdit={() => onEdit(comprador, comprador)}>
            <CardCompradorInfo
              imagem={null}
              tipo={t('proposta:cadastro_compradores.tipo.comprador')}
              nome={comprador.nome}
            />
          </CardCompradorContent>
          <ListaProcuradores
            onEdit={(cliente) => onEdit(cliente, comprador)}
            procuradores={obterProcuradoresDoComprador(comprador.id)}
          />
          <ListaVinculosComprador
            onEdit={(cliente) => onEdit(cliente, comprador)}
            vinculos={comprador.vinculos}
            obterProcuradoresDeCompradores={obterProcuradoresDoComprador}
          />
        </CardComprador>
      ))}
    </>
  )
}
